import { AppThunk } from '../../../store/rootReducer';
import * as createActions from '../actions/create.actions';
import { createModeSelector } from '../selectors/create.selectors';

export const unsetCreateMode = (): AppThunk => async (dispatch, getState) => {
  const createMode = createModeSelector(getState());

  if (createMode === null) {
    return;
  }

  dispatch(createActions.unsetMode({ meta: { history: false } }));
};
